import { ActivatedRoute, Router } from '@angular/router';
import { Component, Injectable } from '@angular/core';
import { EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ConfirmationDialogComponent } from 'src/app/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from 'src/app/confirmation-dialog/confirmation-dialog.service';
import { DatePipe } from '@angular/common';
import { HttpService } from 'src/app/services/http.service';
import { NgForm } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { URLUtils } from 'src/app/urlUtils';
import { ensureActiveSubscription } from 'src/app/shared/subscription-dialog';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialogComponent } from 'src/app/success-dialog/success-dialog.component';

@Component({
    selector: 'app-practice-partner',
    templateUrl: './practice-partner.component.html',
    styleUrls: ['./practice-partner.component.scss'],
    standalone: false
})
@Injectable()
export class PracticePartnerComponent {
  @Input() member: any;
  selectedValue: string = "view";
  selectedMatter: string = "practicepartner";
  selectedValueButton: string = "yes";

  isDisplay:boolean=true;
  isDisabled: any;
  disable = false;
  myForm: any;

  selectedUser: any;
  activeTab = '';
  searchText: string = '';
  partner: any;
  partnerns: any;
  arg: any;
  members: any[]=[]

  isReverse:boolean=false;
  partnerList: any[] = [];

  selectedMember:any;
  isEdit:boolean=false;
  isAdd:boolean = false;
  searchValue:string = '';
  submitted = false;
 
  minLength:any;
  maxLength:any;
  link:any;
  namePattern = /^[A-Z][A-z\s]*$/; ///^[A-Z][a-z]*$/;
  emailPattern = /^[a-za-z0-9._%+-]+@[a-za-z0-9.-]+\.[a-za-z]{2,}$/;
  //emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
 
  //email:any;
  payload: any;
  data: any;
  relNextCursor:any;
  relPrevCursor:any; 
  currentPage: number = 1;
  itemsPerPage: number = 10;
 

  constructor(private fb: FormBuilder,
    private httpservice: HttpService, 
    private router: Router, private dialog: MatDialog,
    private toast: ToastrService,
    private activeRoute: ActivatedRoute,private spinnerService: NgxSpinnerService,
    private confirmationDialogService: ConfirmationDialogService) { }

  ngOnInit() {
    //Get Practice partner API
    this.getData()

    this.myForm = this.fb.group({
    
      name: ['', [Validators.required]],
      designation: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(10), Validators.maxLength(10)]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      practice: ['', [Validators.required]],
    })
  }

  getData() {
    if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }

    this.spinnerService.show();
    this.httpservice.sendGetRequest(URLUtils.getPartners).subscribe(
      (res: any) => {
        this.spinnerService.hide();
        if (res.error == false) {
          //this.members = res.data.members;
          this.members = res.data;
          this.members.reverse();
          this.data = res;
         
        }
      },
      (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          this.spinnerService.hide();
          this.toast.error(error.error.msg || 'Unauthorized');
        } else if (error.error?.msg) {
        } else {
          this.toast.error('An error occurred while updating profile');
        }
      }
    )
  }

  editMember(member: any) {
    if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }
    this.selectedMember = member;
    this.isEdit = true;
  }

  addMember(){
    if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }
    this.isAdd = true;
  }

  addPartner() {

    this.submitted = true;
    
    var addPartner = this.myForm.value
    // console.log('addPartner',addPartner)
    let payload = {
      // "first_name": addPartner.first_name,
      "name": addPartner.name,
      "designation": addPartner.designation,
      "phone": addPartner.phone,
      "email": addPartner.email,
      "practice": addPartner.practice

    }

    if (this.myForm.valid) {
      this.httpservice.sendPostRequest(URLUtils.getPartners, payload).subscribe((res: any) => {

        if (res.error == false) {
          this.toast.success("Practice Partner Added Successfully");
          this.getData();
          this.backToInfo();
          this.onReset();
        }
        else if (res.error == true) {
          this.toast.error(res.msg);
        }
        // check for status code 400
       
      },
                (error: HttpErrorResponse) => {
                  if (error.status === 401 || error.status === 403 || error.status === 400) {
                    const errorMessage = error.error.msg || 'Unauthorized';
                    this.toast.error(errorMessage);
                    //console.log(error);
                  }
                })

    }

   
  }

  deletePartner(member: any) {
    //let isDeleted: boolean = false;
    this.selectedMember = member;
   
     
    if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }

    const msg = `Are you sure, Do you want to delete this ${this.selectedMember?.name} Partner?`
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Confirmation', message: msg }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      //console.log('Dialog result:', result);
      if (result) {
        this.httpservice.sendDeleteRequest(URLUtils.deletePartners(this.selectedMember)).subscribe((res: any) => {
          if (!res.error) {
            this.toast.success("Practice Partner Deleted Successfully");
            this.getData();
            this.backToInfo();
          }
          else {
            this.toast.error(res.msg);
          }
        },(error) => {
            if (error.status === 401 || error.status === 403 || error.status === 400) {
              const errorMessage = error.error.msg || 'Unauthorized';
              this.toast.error(errorMessage);
              //console.log(error);
            }
          }
        );
      }
    });


    // this.confirmationDialogService.confirm('Confirmation', 
    // ' Are you sure, Do you want to delete this ' + this.selectedMember?.name + ' Partner?', 
    // true, 'Yes', 'No')
    //   .then((confirmed) => {
    //     if (confirmed) {
    //       this.httpservice.sendDeleteRequest(URLUtils.deletePartners(this.selectedMember)).subscribe((res: any) => {
    //         if (!res.error) {
    //           if (confirmed) {
    //             this.toast.success("Practice Partner Deleted Successfully");
    //             this.getData();
    //             this.backToInfo();
    //           }
    //           else {
    //             this.toast.error(res.msg);
    //           }
    //         }
    //       },
    //       (error) => {
    //         if (error.status === 401 || error.status === 403 || error.status === 400) {
    //           const errorMessage = error.error.msg || 'Unauthorized';
    //           this.toast.error(errorMessage);
    //           //console.log(error);
    //         }
    //       }
    //     );
    //     }
    //   })
  }

  // updatePartner(member: any) {
  //   //let isDeleted: boolean = false;
  //   this.selectedMember = member;
  //   console.log('this.selectedMember', this.selectedMember)
  //   this.confirmationDialogService.confirm('Confirmation',
  //     ' Are you sure to upgrade ' + this.selectedMember?.first_name + ' ' + this.selectedMember?.last_name
  //     + ' to Practice Partner and provide Super User access?',

  //     true, 'Yes', 'No')
  //     .then((confirmed) => {
  //       if (confirmed) {
  //         let payload = {
  //           "email": this.selectedMember?.email
  //         }
  //         this.httpservice.sendPatchRequest(URLUtils.updatePartner, payload).subscribe((res: any) => {
  //           if (!res.error) {
  //             if (confirmed) {
  //               //this.toast.success(res.msg);
  //               this.confirmationDialogService.confirm('Success', 'You have successfully upgraded ' + this.selectedMember?.first_name + ' ' + this.selectedMember?.last_name + ' to Practice Partner List.', false, '', '', false, 'sm', false)
  //               this.getData();
  //               this.backToInfo();
  //             }
  //             else {
  //               this.toast.error(res.msg);
  //             }
  //           }
  //         }, (error) => {
  //           if (error.status === 401 || error.status === 403 || error.status === 400) {
  //             const errorMessage = error.error.msg || 'Unauthorized';
  //             this.toast.error(errorMessage);
  //             //console.log(error);
  //           }
  //         }
  //         );




  //       }
  //     })
  // }

  editPartner(member: any) {
    this.submitted = true;
    this.isEdit = true;

    var addPartner = this.myForm.value

    let payload = {
     
      "name": addPartner.name,
      "designation": addPartner.designation,
      "phone": addPartner.phone,
      "email": addPartner.email,
      "practice": addPartner.practice
    }


    if (this.myForm.valid) {
      this.httpservice.sendPutRequest(URLUtils.updatePartners(this.selectedMember), payload).subscribe((res: any) => {
        if (res.error == false) {
          this.toast.success("Practice Partner Updated Successfully");
          this.getData();
          this.backToInfo();
          this.onReset();
        }
        else if (res.error == true) {
          this.toast.error(res.msg);
        }
      })
    }

  }

  sortingFile(val: any) {
    this.isReverse = !this.isReverse;
    if (this.isReverse) {
      this.members = this.members?.sort((p1: any, p2: any) => (p1[val] < p2[val]) ? 1 : (p1[val] > p2[val]) ? -1 : 0);
      
    } else {
      this.members = this.members?.sort((p1: any, p2: any) => (p1[val] > p2[val]) ? 1 : (p1[val] < p2[val]) ? -1 : 0);
      
    }
  }

  onClick(value: string) {
    this.selectedMatter = value;
  }

  isActive(value: string) {
    this.selectedValue = value;
    this.selectedValueButton = value;
  }

  onKeydown(event: any) {
    if (event.key === "Enter" || event.type === "click") {
      this.httpservice.sendGetEmailRequest(URLUtils.searchMessages({ "token": localStorage.getItem('TOKEN'), "rows": 10, "search": this.searchText })).subscribe(
        (res: any) => {

        })
    }
  }

  onCancel() {
    if (this.myForm.dirty || this.myForm.touched) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: { title: 'Confirmation', message: `Changes you made may not be saved. Do you want to continue?` }
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.submitted = false;
          this.myForm.reset();
          this.isEdit = false;
          this.isAdd = false;
        }
      });
    }
    else {
      this.submitted = false;
      this.myForm.reset();
      this.isEdit = false;
      this.isAdd = false;
    }
  }
  onReset() {
    this.submitted = false;
    this.myForm.reset();
    this.isEdit = false;
    this.isAdd = false;
  }
  goBack(): void {
    this.router.navigate(['/appointments']);
  }
  backToInfo(){
    this.selectedMember = true
    this.isEdit = false
    this.isAdd = false
 }

 get paginatedMembers() {
  const filteredMembers = this.members.filter(member =>
    !this.searchText ||
    member.name?.toLowerCase().includes(this.searchText.toLowerCase()) ||
    member.email?.toLowerCase().includes(this.searchText.toLowerCase()) ||
    member.phone?.toLowerCase().includes(this.searchText.toLowerCase()) ||
    member.designation?.toLowerCase().includes(this.searchText.toLowerCase()) ||
    member.practice?.toLowerCase().includes(this.searchText.toLowerCase())
  );

  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;

  return filteredMembers.slice(startIndex, endIndex);
}

get totalPages(): number {
  return Math.ceil(
    this.members.filter(member =>
      !this.searchText ||
      member.name?.toLowerCase().includes(this.searchText.toLowerCase()) ||
      member.email?.toLowerCase().includes(this.searchText.toLowerCase()) ||
      member.phone?.toLowerCase().includes(this.searchText.toLowerCase()) ||
      member.designation?.toLowerCase().includes(this.searchText.toLowerCase()) ||
      member.practice?.toLowerCase().includes(this.searchText.toLowerCase())
    ).length / this.itemsPerPage
  );
}


next() {
  if (this.currentPage < this.totalPages) {
    this.currentPage++;
  }
}

prev() {
  if (this.currentPage > 1) {
    this.currentPage--;
  }
}

}


